import {WORKER_SEND_TYPE, WORKER_EVENT_TYPE, AVType,STREAM_BUSI_TYPE} from '../constant'
import EventEmitter from 'eventemitter3';
import AudioPlayer from '../audioplayer/audioplayer.js';
import PlayerUI from '../ui/playerui.js';
import CanvasRender from '../render/canvasrender.js';
import VideoMSERender from '../render/videomserender.js';
import MSEController from '../render/mse/msecontroller.js';
import { EVENTS } from '../constant/events.js';
import {logger} from '../utils/logger.js';
import AudioCollection from '../audiocollection/audiocollection.js';
import VideoWebRtcRender from '../render/videowebrtcrender.js';
import { SRSWebrtc } from '../protocol/hm/srswebrtc.js';


class MainPlayer extends EventEmitter  {


    worker = undefined;
    player;
    audioplayer = undefined;
    audiocollection = undefined;
    render = undefined;
    mserender = undefined;
    wrtrender = undefined
    srsWebrtc = undefined

    isDestoryed = false;

    tag = 'MainPlayer'

    constructor (player) {

        super()

        this.player = player;

        logger.info(this.tag, `start worker thread ${player.options.decoderMode}`);

        if (this.player.options.useWebRtcRender) {

            this.playerui = new PlayerUI(this.player)
            this.wrtrender = new VideoWebRtcRender(this.player, this.playerui.getVideo())

            if (this.player.options.streamBusiType == STREAM_BUSI_TYPE.hmWebRtc) {

                this.srsWebrtc = new SRSWebrtc();
                
                this.wrtrender.createOfferSDP().then((offerSDP) => {
                    console.log(offerSDP,'offerSDP');
                    this.srsWebrtc.startWebrtc(this.player.options.webrtcUrl, offerSDP).then((answerSDP) => {

                        this.wrtrender.setAnswerSDP(answerSDP);

                    }).catch((error) => {

                        logger.info(this.tag, `SRSWebrtc start fail ${JSON.stringify(error)}`);

                    })

                }) 
            }


        } else {

            this.audiocollection = new AudioCollection(player)
        
            this.createWorker()

        }




    }

    createWorker() {

        this.worker = new Worker('worker.js');

        this.worker.onmessageerror = (event) => {

            logger.info(this.tag, `start worker thread err ${event}`);
        };

        this.worker.onmessage = (event) => {

            const msg = event.data;
            switch (msg.cmd) {

                case WORKER_EVENT_TYPE.created: {

                    this.worker.postMessage({
                                                cmd: WORKER_SEND_TYPE.init,
                                                options:JSON.stringify(this.player.options)});
                    break;

                }

                case WORKER_EVENT_TYPE.inited: {

                    break;

                }

                case WORKER_EVENT_TYPE.destroyed: {

                    logger.info(this.tag, 'mediacenter receive destroyed msg');

                    this.worker.terminate()

                    if (this.destroyResolve) {
                        logger.info(this.tag, 'mediacenter receive destroyed msg and complete async destroyWorker task');
                        this.destroyResolve()
                        this.destroyResolve = undefined

                    }

                    break;
                }

                case WORKER_EVENT_TYPE.updateRenderOptions: {
                    
                    //这3个属性获取到音视频参数后才能确定
                    this.player.options.renderMode = msg.renderMode
                    this.player.options.useMSEAudioWhenMSERenderMode = msg.useMSEAudioWhenMSERenderMode
                    this.player.options.decoderMode = msg.decoderMode
                    
                    this.emit('event', {event:EVENTS.updateOptions, params:this.player.options})

                    logger.info(this.tag, `updateOptions: ${JSON.stringify(this.player.options)}`);

                    this.initAVRender(msg.mediasourceHandle)


                    let offScreenCanvas 
                    let transferList = []
                    if (this.player.options.renderMode == 'canvas' && this.player.options.useOffScreenCanvasRender) {

                        offScreenCanvas = this.playerui.getOffScreenCanvas()
                        transferList.push(offScreenCanvas);
                    } 

                    this.worker.postMessage({
                        cmd: WORKER_SEND_TYPE.renderOptionsUpdated, offScreenCanvas}, transferList);

                    break
                }

                case WORKER_EVENT_TYPE.videoInfo: {

                    break;
                }

                    
                case WORKER_EVENT_TYPE.videoFrame: {

                    if(this.isDestoryed) {

                        return;
                    }

                    this.render.renderOneFrame(msg.videoFrame, msg.ext);

                    break;
                }

                case WORKER_EVENT_TYPE.audioInfo: {

                    this.audioplayer?.setAudioInfo(msg.atype, msg.sampleRate, msg.channels, msg.samplesPerPacket).then(()=>{

                        if (this.player.options.audioEngine == 'worklet') {

                            this.worker.postMessage({
                                cmd: WORKER_SEND_TYPE.initWorkletMesssagePort, port:this.audioplayer.workletNode.port}, [this.audioplayer.workletNode.port]);
                        }

                    });

                    break;
                }


                case WORKER_EVENT_TYPE.pcmData: {

                    if(this.isDestoryed) {

                        return;
                    }

                    let packet = {

                        datas:msg.datas, 
                        timestamp:msg.timestamp, 
       
                    }

                    this.audioplayer.pushPcmData(packet);

                    break;

                }

                case WORKER_EVENT_TYPE.recordFinish: {

                    if(this.isDestoryed) {

                        return;
                    }

                    let data = msg.data

                    // 将数据保存到本地
                    const blob = new Blob([data.buffer], { type: 'video/mp4' });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = 'output.mp4';
                    document.body.appendChild(link);
                    link.click();

                    break;
                }


                case  WORKER_EVENT_TYPE.initSegment:{

                    this.msectrl.appendInitSegment(msg.segment)
                    
                    break;
                }

                case  WORKER_EVENT_TYPE.mediaSegment:{

                    this.msectrl.appendMediaSegment(msg.segment)

                    break;
                }

                case  WORKER_EVENT_TYPE.event:{
                    
                    this.emit('event', msg.evtobj);
                    break
                }

                case  WORKER_EVENT_TYPE.playAbnormal:{
                    
                    this.emit('playAbnormal', msg.info);
                    break
                }

                case  WORKER_EVENT_TYPE.requestEncWSSKey:{
                    
                    this.emit('requestEncWSSKey', msg.encWssKey);
                    break
                }

                case  WORKER_EVENT_TYPE.logData:{
                    
                    logger.appendLog(msg.log)
                    break
                }
                
                default: {

                    break;
                }
                   
            }

        };
    }

   initAVRender(mediasourceHandle) {

        this.playerui = new PlayerUI(this.player);

        if (this.player.options.renderMode == 'canvas') {

            if (!this.player.options.useOffScreenCanvasRender) {

                this.render = new CanvasRender(this.player, this.playerui.getCanvas());  // render yuv
            }

        } else { //mse

            this.mserender = new VideoMSERender(this.player, this.playerui.getVideo());

            if (!this.player.options.useWorkerForMSE) {

                this.msectrl = new MSEController(this.player);
                this.msectrl.on('playAbnormal', (info) => {

                    this.emit('playAbnormal', info)
                })
                this.mserender.setMediaSourceObjectUrl(this.msectrl.getObjectURL());

            } else {

                this.mserender.setMediaSourceHandle(mediasourceHandle)
            }
            
        }

        if (this.player.options.renderMode != 'mse' || !this.player.options.useMSEAudioWhenMSERenderMode) {

            this.audioplayer = new AudioPlayer(this.player);
        }

    }

    async destroyWorker() {

        return new Promise(resolve => {

            this.destroyResolve = resolve
            this.worker.postMessage({cmd: WORKER_SEND_TYPE.destroy});
            
            setTimeout(() => {
                
                if(this.destroyResolve) {
                    this.worker.terminate()
                    this.destroyResolve()
                    this.destroyResolve = undefined
                    logger.warn(this.tag, 'MainPlayer wait for 3 sec but destroyed msg not received, so force async destroyWorker task complete');
                }

            }, 3000);


        })

        
    }

    async destroy() {

        this.removeAllListeners();
        this.isDestoryed = true;

        if (this.worker) {

            await this.destroyWorker()
        } 


        this.srsWebrtc?.destroy()
        this.wrtrender?.destroy()
        this.audioplayer?.destroy();
        this.render?.destroy();
        this.msectrl?.destroy()
        this.mserender?.destroy();
        this.playerui?.destroy()
        this.audiocollection?.destroy()

        logger.info(this.tag, 'MainPlayer destroy');
 
    }

    unMute() {

        if (this.player.options.useWebRtcRender) {

            this.wrtrender.unMute()

        } else if (this.player.options.renderMode == 'mse' && this.player.options.useMSEAudioWhenMSERenderMode) {

            this.mserender.unMute();

        } else {

            this.audioplayer.unMute();
            
        }

        
    }

    mute() {

        if (this.player.options.useWebRtcRender) {

            this.wrtrender.mute()

        } else if (this.player.options.renderMode == 'mse'&& this.player.options.useMSEAudioWhenMSERenderMode) {

            this.mserender.mute();
        } else {

            this.audioplayer.mute();
        }
 
    }

    setVolume(num) {

        if (this.player.options.useWebRtcRender) {

            this.wrtrender.setVolume(num);

        } else if (this.player.options.renderMode == 'mse'&& this.player.options.useMSEAudioWhenMSERenderMode) {

            this.mserender.setVolume(num);
        } else {

            this.audioplayer.setVolume(num);
        }
    }

    switchRender(canvasRenderMode) {

        if (this.player.options.renderMode != 'canvas') {

            return
        }

        if (this.player.options.useOffScreenCanvasRender) {

            this.worker.postMessage({
                cmd: WORKER_SEND_TYPE.switchRender, canvasRenderMode});

        } else {

            this.render.switchRender(canvasRenderMode);
        }

    }

    startRecord(recordAVMode) {

        this.worker.postMessage({
            cmd: WORKER_SEND_TYPE.startRecord, recordAVMode});
    }

    stopRecord() {

        this.worker.postMessage({
            cmd: WORKER_SEND_TYPE.stopRecord});
    }

    resizeView() {
        this.playerui?.resizeView()

        this.render?.resizeView()

        this.worker.postMessage({
            cmd: WORKER_SEND_TYPE.resizeView, params:{ x:this.player.options.x,
                                                       y:this.player.options.y,
                                                       width:this.player.options.width,
                                                       height:this.player.options.height }}); 
    }

    updateRenderOptions() {

        this.playerui?.updateRenderOptions()
        this.render?.updateRenderOptions()

        this.worker?.postMessage({
            cmd: WORKER_SEND_TYPE.updateRenderOptions, renderOptions:this.player.options.renderOptions}); 
        
    }

    setFullscreen(flag) {

        this.playerui?.setFullscreen(flag)
    
    }

    isFullscreen() {

       return this.playerui?.isFullscreen() ?? false
    }

    startTalk(talkParams) {

        if (this.player.options.useWebRtcRender) {

            this.wrtrender?.startTalk()

        } else {

            this.audiocollection?.start().then(()=>{

                let port = this.audiocollection.getMessagePort()
    
                this.worker.postMessage({cmd: WORKER_SEND_TYPE.startTalk, port, talkParams}, [port]);
    
            }).catch(e => {
    
                logger.error(this.tag, `startTalk error: ${e}`);
    
            })

        }

    }

    stopTalk() {

        if (this.player.options.useWebRtcRender) {

            this.wrtrender?.stopTalk()

        } else {

            this.audiocollection?.stop()

            this.worker.postMessage({cmd: WORKER_SEND_TYPE.stopTalk});

        }


    }

    seekTFCardStream(playTime) {

        this.worker.postMessage({cmd: WORKER_SEND_TYPE.seekTFCardStream, playTime});
    }

    seekCloudStream(playTime) {

        this.worker.postMessage({cmd: WORKER_SEND_TYPE.seekCloudStream, playTime});
    }

    startEncWSSStream(playUrl) {

        this.worker?.postMessage({cmd: WORKER_SEND_TYPE.startEncWSSStream, playUrl});
    }

    playScaleStream(playSpeed) {

        this.worker.postMessage({cmd: WORKER_SEND_TYPE.playScaleStream, playSpeed});
    }

    pauseStream() {
        this.worker.postMessage({cmd: WORKER_SEND_TYPE.pauseStream});
    }

    resumeStream() {
        this.worker.postMessage({cmd: WORKER_SEND_TYPE.resumeStream});
    }
}



export default  MainPlayer;
